import * as React from "react";
import "./presenter.scss";

interface IProps {
	value: string[];
}

export const TagsPresenter: React.SFC<IProps> = (props) => {
	return (
		<div>
			{props.value.map((tag, index) => <div key={index}>{tag}</div>)}
		</div>
	);
};

